import React, { Component } from 'react';
import { toast } from 'react-toastify';
import ReactCustomFlagSelect from '../../ReactCustomFlagSelect';
import staticData from '../../static';
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import CarOptionList from './CarOptionList';
import { carMakeList, carColorList } from '../../static';
import {
  nonSpecialCharacterForValue,
  isValidEmail,
  PICKER_LANG,
  getMonthPickerLimits,
  formatMonthYear
} from '../helpers/monthlyRegistrationHelpers';
import '../../styles/monthly-registration/monthlyRegistration.css';

export default class IndividualInfoForm extends Component {
  constructor(props) {
    super(props);
    this.pickMulti = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (this.pickMulti.current && 
        !e.target.closest('.rmp-popup') &&
        !e.target.closest('.customer-info-form__date-trigger') &&
        !e.target.closest('.customer-info-form__date-picker')) {
      try {
        this.pickMulti.current.dismiss();
      } catch (err) {}
    }
  };

  handleChange = (e) => {
    this.props.onIndividualChange?.(e);
    if (e.target.name === 'vehicle_no') {
      setTimeout(() => this.validateForm(false), 100);
    }
  };

  handleAreaCode = (areaCode) => this.props.onIndividualAreaCode?.(areaCode);

  handleDateChange = (year, month) => {
    this.props.onIndividualDateChange?.({ year, month });
    this.pickMulti.current?.dismiss();
  };

  addAlternateVehicle = () => this.props.onAddAlternateVehicle?.();
  removeAlternateVehicle = (index) => this.props.onRemoveAlternateVehicle?.(index);
  updateAlternateVehicle = (index, field, value) => this.props.onUpdateAlternateVehicle?.(index, field, value);

  openCarMakeModal = () => this.props.onOpenCarMakeModal?.();
  openCarColorModal = () => this.props.onOpenCarColorModal?.();
  openAlternateCarMakeModal = (index) => this.props.onOpenAlternateCarMakeModal?.(index);
  openAlternateCarColorModal = (index) => this.props.onOpenAlternateCarColorModal?.(index);
  closeModal = () => this.props.onCloseModal?.();

  handleCarMakeChange = (value) => this.props.onCarMakeChange?.(value);
  handleCarColorChange = (value) => this.props.onCarColorChange?.(value);
  handleAlternateCarMakeChange = (value) => this.props.onAlternateCarMakeChange?.(value);
  handleAlternateCarColorChange = (value) => this.props.onAlternateCarColorChange?.(value);

  validateForm = (showErrors = false) => {
    const errors = {};
    const fields = this.props.fields || {};
    const validity = this.props.validity;
    let isValid = true;

    if (showErrors) {
      if (!fields.first_name) { errors.first_name = 'First name is required'; isValid = false; }
      if (!fields.last_name) { errors.last_name = 'Last name is required'; isValid = false; }
      if (!fields.phone1) { errors.phone1 = 'Mobile number is required'; isValid = false; }
      if (!fields.email) { errors.email = 'Email is required'; isValid = false; }
      if (!validity?.year || !validity?.month) { errors.startDate = 'Start date is required'; isValid = false; }
      if (!fields.vehicle_no) { errors.vehicle_no = 'License plate is required'; isValid = false; }
      
      if (fields.email && !isValidEmail(fields.email)) {
        toast.error('Please enter a valid email address');
        isValid = false;
      }
    }
    
    if (fields.vehicle_no && nonSpecialCharacterForValue(fields.vehicle_no)) {
      errors.vehicle_no = 'Special characters are not allowed in license plate';
    }

    (this.props.alternateVehicles || []).forEach((alt, index) => {
      if (alt.vehicle_no && nonSpecialCharacterForValue(alt.vehicle_no)) {
        errors[`alternate_vehicle_${index}_vehicle_no`] = 'Special characters are not allowed in license plate';
      }
    });

    this.props.onSetIndividualErrors?.(errors);
    return isValid && Object.keys(errors).length === 0;
  };

  isFormValid = () => {
    const fields = this.props.fields || {};
    const validity = this.props.validity;
    const alternateVehicles = this.props.alternateVehicles || [];
    
    return !!fields.first_name && !!fields.last_name && !!fields.phone1 && !!fields.email &&
           validity?.year && validity?.month &&
           !!fields.vehicle_no && !nonSpecialCharacterForValue(fields.vehicle_no) &&
           alternateVehicles.every(alt => !alt.vehicle_no || !nonSpecialCharacterForValue(alt.vehicle_no));
  };

  handleContinue = (e) => {
    e.preventDefault();
    if (this.props.submittingForm) return;
    if (!this.validateForm(true)) return;
    if (this.props.onContinueToPayment) {
      this.props.onContinueToPayment();
    } else {
      toast.error('Unable to submit form');
    }
  };

  renderRemoveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="customer-info-form__remove-icon">
      <path d="M18 6 6 18"></path>
      <path d="m6 6 12 12"></path>
    </svg>
  );

  renderAddIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="customer-info-form__add-icon">
      <path d="M5 12h14"></path>
      <path d="M12 5v14"></path>
    </svg>
  );

  renderCalendarIcon = () => (
    <svg className="customer-info-form__calendar-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  );

  renderCarSelectField = (label, value, onClick, error, required = false) => (
    <div className="customer-info-form__field">
      <label className="customer-info-form__label">{label}{required && <span className="required">*</span>}</label>
      <div className="customer-info-form__input-with-icon" onClick={onClick} style={{ cursor: 'pointer' }}>
        <input
          type="text"
          value={value}
          onClick={(e) => { e.stopPropagation(); onClick(); }}
          placeholder={`Select ${label.toLowerCase()}`}
          className={`customer-info-form__input ${error ? 'error' : ''}`}
          style={{ textTransform: 'capitalize', cursor: 'pointer' }}
          readOnly
        />
        <i className="fa fa-list customer-info-form__icon" onClick={(e) => { e.stopPropagation(); onClick(); }} aria-hidden="true"></i>
      </div>
      {error && <span className="customer-info-form__error">{error}</span>}
    </div>
  );

  renderAlternateVehicle = (altVehicle, index, errors) => (
    <div key={index} className="customer-info-form__alternate-vehicle">
      <div className="customer-info-form__alternate-vehicle-header">
        <label className="customer-info-form__label">Alternate Vehicle {index + 1}</label>
        <button type="button" onClick={() => this.removeAlternateVehicle(index)} className="customer-info-form__remove-btn">
          {this.renderRemoveIcon()}
        </button>
      </div>
      <div className="customer-info-form__field">
        <label className="customer-info-form__label">License Plate</label>
        <input
          type="text"
          value={altVehicle.vehicle_no}
          onChange={(e) => {
            this.updateAlternateVehicle(index, 'vehicle_no', e.target.value);
            setTimeout(() => this.validateForm(false), 100);
          }}
          placeholder="ENTER LICENSE PLATE"
          className={`customer-info-form__input customer-info-form__input--uppercase ${errors[`alternate_vehicle_${index}_vehicle_no`] ? 'error' : ''}`}
          style={{ textTransform: 'uppercase' }}
          onKeyPress={(e) => nonSpecialCharacterForValue(e.key) && e.preventDefault()}
        />
        {errors[`alternate_vehicle_${index}_vehicle_no`] && (
          <span className="customer-info-form__error">{errors[`alternate_vehicle_${index}_vehicle_no`]}</span>
        )}
      </div>
      <div className="customer-info-form__row">
        {this.renderCarSelectField('Car Make', altVehicle.vehicle_make, () => this.openAlternateCarMakeModal(index))}
        {this.renderCarSelectField('Color', altVehicle.vehicle_color, () => this.openAlternateCarColorModal(index))}
      </div>
    </div>
  );

  render() {
    const fields = this.props.fields || {};
    const alternateVehicles = this.props.alternateVehicles || [];
    const errors = this.props.errors || {};
    const validity = this.props.validity;
    const { showCarMakeModal, showCarColorModal, showAlternateCarMakeModal, showAlternateCarColorModal, currentAlternateIndex, parkingId } = this.props;

    const { min: monthPickerLimitMin, max: monthPickerLimitMax } = getMonthPickerLimits(parkingId);

    return (
      <form onSubmit={this.handleContinue} className="customer-info-form" noValidate>
        <div className="customer-info-card">
          <div className="customer-info-card__header">
            <h3 className="customer-info-card__title">Personal Information</h3>
          </div>
          <div className="customer-info-card__content">
            <div className="customer-info-form__row">
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">First Name <span className="required">*</span></label>
                <input type="text" name="first_name" value={fields.first_name} onChange={this.handleChange} placeholder="Enter first name" className={`customer-info-form__input ${errors.first_name ? 'error' : ''}`} />
                {errors.first_name && <span className="customer-info-form__error">{errors.first_name}</span>}
              </div>
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">Last Name <span className="required">*</span></label>
                <input type="text" name="last_name" value={fields.last_name} onChange={this.handleChange} placeholder="Enter last name" className={`customer-info-form__input ${errors.last_name ? 'error' : ''}`} />
                {errors.last_name && <span className="customer-info-form__error">{errors.last_name}</span>}
              </div>
            </div>

            <div className="customer-info-form__field">
              <label className="customer-info-form__label">Mobile Number <span className="required">*</span></label>
              <div className="customer-info-form__phone-group">
                <div className="customer-info-form__country-code">
                  <ReactCustomFlagSelect showSearch={false} showArrow={true} animate={true} value={fields.areaCode} customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }} optionList={staticData.countryCode} onChange={this.handleAreaCode} />
                </div>
                <input type="tel" name="phone1" value={fields.phone1} onChange={this.handleChange} placeholder="Phone number" className={`customer-info-form__input customer-info-form__input--phone ${errors.phone1 ? 'error' : ''}`} />
              </div>
              {errors.phone1 && <span className="customer-info-form__error">{errors.phone1}</span>}
            </div>

            <div className="customer-info-form__field">
              <label className="customer-info-form__label">Email Address <span className="required">*</span></label>
              <input type="text" name="email" value={fields.email ?? ''} onChange={this.handleChange} placeholder="Enter email address" className={`customer-info-form__input ${errors.email && !fields.email ? 'error' : ''}`} />
              {errors.email && !fields.email && <span className="customer-info-form__error">{errors.email}</span>}
            </div>

            <div className="customer-info-form__row">
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">Unit Number (Optional)</label>
                <input type="text" name="unit_number" value={fields.unit_number} onChange={this.handleChange} placeholder="Apt/Unit number" className="customer-info-form__input" />
              </div>
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">Select Start Date <span className="required">*</span></label>
                <div className="customer-info-form__date-picker">
                  <Picker ref={this.pickMulti} years={{ min: monthPickerLimitMin, max: monthPickerLimitMax }} value={validity} onChange={this.handleDateChange} lang={PICKER_LANG.months} theme="light">
                    <div className="customer-info-form__date-trigger" onClick={(e) => { e.stopPropagation(); this.pickMulti.current?.show(); }}>
                      {this.renderCalendarIcon()}
                      <span>{formatMonthYear(validity)}</span>
                    </div>
                  </Picker>
                </div>
                {errors.startDate && <span className="customer-info-form__error">{errors.startDate}</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="customer-info-card">
          <div className="customer-info-card__header">
            <h3 className="customer-info-card__title">Vehicle Information</h3>
          </div>
          <div className="customer-info-card__content">
            <div className="customer-info-form__field">
              <label className="customer-info-form__label">License Plate <span className="required">*</span></label>
              <input
                type="text"
                name="vehicle_no"
                value={fields.vehicle_no}
                onChange={this.handleChange}
                placeholder="ENTER LICENSE PLATE"
                className={`customer-info-form__input customer-info-form__input--uppercase ${errors.vehicle_no ? 'error' : ''}`}
                style={{ textTransform: 'uppercase' }}
                onKeyPress={(e) => nonSpecialCharacterForValue(e.key) && e.preventDefault()}
              />
              {errors.vehicle_no && <span className="customer-info-form__error">{errors.vehicle_no}</span>}
            </div>

            <div className="customer-info-form__row customer-info-form__row--three">
              {this.renderCarSelectField('Car Make', fields.vehicle_make, this.openCarMakeModal)}
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">Model</label>
                <input type="text" name="vehicle_model" value={fields.vehicle_model} onChange={this.handleChange} placeholder="e.g., Camry" className="customer-info-form__input" />
              </div>
              {this.renderCarSelectField('Color', fields.vehicle_color, this.openCarColorModal)}
            </div>

            {alternateVehicles.map((altVehicle, index) => this.renderAlternateVehicle(altVehicle, index, errors))}

            <button type="button" onClick={this.addAlternateVehicle} className="customer-info-form__add-btn">
              {this.renderAddIcon()}
              <span>Add Alternate Vehicle</span>
            </button>
          </div>
        </div>

        <div className="customer-info-form__actions">
          <button type="button" onClick={this.props.onBack} className="customer-info-form__btn customer-info-form__btn--back" disabled={this.props.submittingForm}>Back</button>
          <button type="submit" className="customer-info-form__btn customer-info-form__btn--continue" disabled={!this.isFormValid() || this.props.submittingForm} style={{ opacity: (this.isFormValid() && !this.props.submittingForm) ? 1 : 0.5, cursor: (this.isFormValid() && !this.props.submittingForm) ? 'pointer' : 'not-allowed' }}>{this.props.submittingForm ? 'Loading...' : 'Continue'}</button>
        </div>

        {showCarMakeModal && <CarOptionList type="car_make" title="Car Make" list={carMakeList} selection={fields.vehicle_make} handleChange={this.handleCarMakeChange} close={this.closeModal} />}
        {showCarColorModal && <CarOptionList type="car_color" title="Car Color" list={carColorList} selection={fields.vehicle_color} handleChange={this.handleCarColorChange} close={this.closeModal} />}
        {showAlternateCarMakeModal && currentAlternateIndex !== null && <CarOptionList type="car_make" title="Car Make" list={carMakeList} selection={alternateVehicles[currentAlternateIndex]?.vehicle_make} handleChange={this.handleAlternateCarMakeChange} close={this.closeModal} />}
        {showAlternateCarColorModal && currentAlternateIndex !== null && <CarOptionList type="car_color" title="Car Color" list={carColorList} selection={alternateVehicles[currentAlternateIndex]?.vehicle_color} handleChange={this.handleAlternateCarColorChange} close={this.closeModal} />}
      </form>
    );
  }
}
